module.exports = __webpack_public_path__ + "media/icons/faq-549796d8.png";